import { Box, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

interface AdditionalInterestModifiedModalProps {
  readonly isOfferSent?: boolean;
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
}

export function AdditionalInterestModifiedModal({
  isModalOpen,
  isOfferSent,
  onClose,
}: AdditionalInterestModifiedModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      title="Policy Updated Successfully"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography variant="h5" sx={{ pr: 5, textAlign: "justify" }}>
        The policy has been updated. The Additional Interest has also been
        applied to the upcoming renewal, as the policy is close to its renewal
        date. A policy document{isOfferSent ? " and renewal offer" : ""}{" "}
        confirming this change will be available in the{" "}
        <Typography variant="h5" component="span" fontWeight="bold">
          Documents
        </Typography>{" "}
        tab shortly.
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
}
